import { Unit } from 'src/app/products/interfaces/unit';

import { IColumn } from '@products/interfaces/models';

import { standaloneSubtypes } from './../../shared/enums/packaging-subtype';

export function getTableColumns(): IColumn[] {
  return [
    {
      field: 'brand',
      label: 'PRODUCTS.TITLE.BRAND',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: true,
      filterable: false,
      sortable: true,
    },
    {
      field: 'name',
      label: 'PRODUCTS.TITLE.NAME',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: true,
      filterable: false,
      sortable: true,
    },
    {
      field: 'eanCodes',
      label: 'PRODUCTS.TITLE.EAN',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: true,
      filterable: false,
      sortable: true,
    },
    {
      field: 'amount',
      label: 'PRODUCTS.TITLE.NET_AMOUNT',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: true,
      filterable: false,
      sortable: true,
      alignment: 'right',
    },
    {
      field: 'unit',
      label: 'PRODUCTS.TITLE.UNIT',
      placeholder: '',
      searchable: false,
      filterable: true,
      sortable: false,
      filterOptions: [
        {
          label: 'SHARED.FILTERS.ALL',
          value: '',
        },
        ...Object.values(Unit).map((key: string) => ({
          label: `PRODUCTS.UNIT.${key}`,
          value: key,
        })),
      ],
    },
    {
      field: 'standalonePackingMethodSubType',
      label: 'PRODUCTS.TITLE.PACKAGING',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: false,
      filterable: true,
      sortable: false,
      filterOptions: [
        {
          label: 'SHARED.FILTERS.ALL',
          value: '',
        },
        ...Object.values(standaloneSubtypes).map((key: string) => ({
          label: `PRODUCTS.PACKAGING.${key}`,
          value: key,
        })),
      ],
    },
    {
      field: 'hasCollectionPackaging',
      label: 'PRODUCTS.TITLE.COLLECTION_UNIT',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: false,
      filterable: true,
      sortable: false,
      filterOptions: [
        {
          label: 'SHARED.FILTERS.ALL',
          value: undefined,
        },
        {
          label: 'PRODUCTS.COLLECTION_UNIT.OPTIONS.EXIST',
          value: true,
        },
        {
          label: 'PRODUCTS.COLLECTION_UNIT.OPTIONS.NOT_EXIST',
          value: false,
        },
      ],
    },
    {
      field: 'actions',
      label: '',
      placeholder: '',
      searchable: false,
      filterable: false,
      sortable: false,
    },
  ] as IColumn[];
}

export function getImportTableColumns(): IColumn[] {
  return [
    {
      field: 'checkbox',
      label: '',
      placeholder: '',
      searchable: false,
      filterable: false,
      sortable: false,
    },
    {
      field: 'name',
      label: 'PRODUCTS.IMPORT.TITLE.FILE_NAME',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: false,
      filterable: false,
      sortable: true,
    },
  ] as IColumn[];
}
export function getImportTableValidationsTableColumns(): IColumn[] {
  return [
    {
      field: 'sheet',
      label: 'PRODUCTS.IMPORT.TABLE_CHECKER.TABLE.TITLE.SHEET',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: false,
      filterable: false,
      sortable: false,
    },
    {
      field: 'column',
      label: 'PRODUCTS.IMPORT.TABLE_CHECKER.TABLE.TITLE.COLUMN',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: false,
      filterable: false,
      sortable: false,
    },
    {
      field: 'rowNumber',
      label: 'PRODUCTS.IMPORT.TABLE_CHECKER.TABLE.TITLE.ROW',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: false,
      filterable: false,
      sortable: false,
    },
    {
      field: 'message',
      label: 'PRODUCTS.IMPORT.TABLE_CHECKER.TABLE.TITLE.MESSAGE',
      placeholder: 'SEARCH.PLACEHOLDER',
      searchable: false,
      filterable: false,
      sortable: false,
    },
  ] as IColumn[];
}
